// extracted by mini-css-extract-plugin
module.exports = {"Container":"Map_Container__1atR2","KeepAspectRatio":"Map_KeepAspectRatio__2bRRD","Image":"Map_Image__2EzOK","Point":"Map_Point__3XaLz","Tooltip":"Map_Tooltip__2MfIM"};